import { Box } from '@mui/material';
import React from 'react';
import type { SnapGuides } from './cropAdjustBoxes';

/**
 * The thin alignment lines shown while dragging/resizing an Adjust-crops box
 * once it snaps to the canvas edges/center or another box's edges/center —
 * same visual convention as Figma/Keynote/PowerPoint "smart guides". Hold
 * Ctrl/Cmd while dragging to turn snapping off; Shift constrains a move to
 * one axis. `guides` is in source px, scaled here like the boxes themselves.
 */
export default function SnapGuideLines({ guides, scale }: { guides: SnapGuides; scale: number }) {
  return (
    <>
      {guides.x !== null && (
        <Box
          aria-hidden
          data-testid="snap-guide-x"
          sx={{
            position: 'absolute',
            pointerEvents: 'none',
            top: 0,
            bottom: 0,
            left: guides.x * scale,
            width: '1px',
            bgcolor: 'error.main',
          }}
        />
      )}
      {guides.y !== null && (
        <Box
          aria-hidden
          data-testid="snap-guide-y"
          sx={{
            position: 'absolute',
            pointerEvents: 'none',
            left: 0,
            right: 0,
            top: guides.y * scale,
            height: '1px',
            bgcolor: 'error.main',
          }}
        />
      )}
    </>
  );
}
